var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOff({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.15301 3.38192C7.43405 3.34938 7.71675 3.33313 7.99967 3.33325C11.109 3.33325 13.5997 5.26859 14.6663 7.99992C14.4081 8.66429 14.0592 9.28977 13.6297 9.85859M4.34634 4.34592C2.98634 5.17592 1.93301 6.46192 1.33301 7.99992C2.39967 10.7313 4.89034 12.6666 7.99967 12.6666C9.28776 12.6734 10.5525 12.3226 11.653 11.6533M6.58634 6.58659C6.40061 6.77232 6.25328 6.99282 6.15276 7.23549C6.05224 7.47816 6.0005 7.73825 6.0005 8.00092C6.0005 8.26358 6.05224 8.52368 6.15276 8.76635C6.25328 9.00902 6.40061 9.22952 6.58634 9.41525C6.77207 9.60098 6.99257 9.74832 7.23524 9.84883C7.47791 9.94935 7.73801 10.0011 8.00067 10.0011C8.26334 10.0011 8.52343 9.94935 8.76611 9.84883C9.00878 9.74832 9.22928 9.60098 9.41501 9.41525",
    stroke: "#909090",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66602 2.66663L13.3327 13.3333",
    stroke: "#909090",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.70fc67727eff6ea329ded0b3fb260bb0.svg";
export { ForwardRef as ReactComponent };